module.exports = __webpack_public_path__ + "i18n/ja.e6d9c585af1ad9a5e3294e4dfd6417ea.json";